module.exports = __webpack_public_path__ + "static/media/random.32bda32a.png";